import React from 'react';

function ErrorIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 63 82"
      className={className}
    >
      <defs>
        <path
          id="a"
          d="M.284 10.479v22.389a9.562 9.562 0 0 0 9.563 9.563 9.562 9.562 0 0 0 9.564-9.563V10.479c0-5.281-4.281-9.563-9.564-9.563a9.563 9.563 0 0 0-9.563 9.563z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g stroke="currentColor" strokeWidth="2">
          <path strokeLinecap="square" d="M31.847 70.315v8.635" />
          <path strokeLinecap="round" d="M22.592 80.084H41.76" />
        </g>
        <g transform="translate(22 22.084)">
          <mask id="b" fill="#fff">
            <use xlinkHref="#a" />
          </mask>
          <path
            stroke="currentColor"
            strokeWidth="4"
            d="M9.847.916a9.563 9.563 0 0 1 9.563 9.563v22.389c0 5.282-4.28 9.564-9.563 9.564-5.282 0-9.563-4.282-9.563-9.564v-22.39A9.563 9.563 0 0 1 9.847.917z"
            mask="url(#b)"
          />
        </g>
        <g stroke="currentColor" strokeLinecap="round" strokeWidth="2">
          <path d="M46.347 48.031v7.174c0 7.924-6.492 14.347-14.5 14.347s-14.5-6.423-14.5-14.347v-7.174M57.17 46.582a30.045 30.045 0 0 0 4.218-15.389C61.388 14.519 47.87 1 31.194 1 14.518 1 1 14.519 1 31.193a30.054 30.054 0 0 0 4.216 15.389" />
          <path d="M11.773 40.026a21.233 21.233 0 0 1-1.93-8.833c0-11.79 9.56-21.35 21.351-21.35 11.791 0 21.35 9.56 21.35 21.35 0 3.154-.702 6.14-1.929 8.833" />
        </g>
      </g>
    </svg>
  );
}

export default ErrorIcon;
